export default __webpack_public_path__ + "static/media/which.af0b1c71.png";